<template>
  <div>
    <header-page :image="18">
      <h1>{{ $t('views.e-appeal.title') }}</h1>
    </header-page>
    <div class="app-container body-page">
      <div class="row">
        <!-- <div class="col-lg-5 col-12 mb-lg-0 mb-5">
          <form-appeal></form-appeal>
        </div> -->
        <div class="col-lg-8 col-12">
          <p>
            Со 2 января 2023 г. встуил в действие с дополнениями и изменениями
            Закон Республики Беларусь от 18 июля 2011 г. № 300-З
            <a
              href="https://pravo.by/document/?guid=3871&p0=h11100300"
              target="_blank"
              style="color: #1461ff"
              >«Об обращениях граждан и юридических лиц»</a
            >
            (ред. от 28.06.2022), который устанавливает подачу в государственные
            органы и иные государственные организации электронных обращений и
            получение ответов (уведомлений) на них посредством государственной
            единой (интегрированной) республиканской информационной системы
            учета и обработки обращений граждан и юридических лиц (система учета
            и обработки обращений).
          </p>
          <p>
            Доступ пользователей к системе учета и обработки обращений
            обеспечивается посредством сайта в глобальной компьютерной сети
            Интернет по адресу
            <a
              href="https://xn--80abnmycp7evc.xn--90ais/"
              target="_blank"
              style="color: #1461ff"
              >https://обращения.бел</a
            >
            (интернет-сайт).
          </p>
          <!-- <description></description> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage';
// import FormAppeal from './components/FormAppeal';
// import Description from './components/Description';

export default {
  name: 'ElectronicAppeal',
  components: {
    HeaderPage,
    // FormAppeal,
    // Description,
  },
};
</script>

<style lang="stylus" scoped>
.body-page {
  margin-top: 50px;
  margin-bottom: 50px;
}
</style>
